module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av379-8d5cf4c6b38a4a9296757eea3d2da740.jpg";